import * as fromDatatype from '../datatype-library';

export interface cookieObject {
    name: string,
    value: string,
    domain: string,
    path: string,
    max_age: fromDatatype.NumericDatatypeInterface,
    secure: boolean,
    is_http_only: boolean,
    version: fromDatatype.NumericDatatypeInterface,
    discard: boolean,
    comment: string,
    comment_url: string,
    port_list: string
}

export interface bl_cms_post_view_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    website_guid: fromDatatype.GuidDataFieldInterface;
    cookie: fromDatatype.GuidDataFieldInterface;
    view_count: fromDatatype.NumericDatatypeInterface;
    latest_time: fromDatatype.TimestampTzDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_post_view_hdr_RowClass implements bl_cms_post_view_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    website_guid: fromDatatype.GuidDataFieldInterface;
    cookie: fromDatatype.GuidDataFieldInterface;
    view_count: fromDatatype.NumericDatatypeInterface;
    latest_time: fromDatatype.TimestampTzDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
